import React from "react";
import { Switch, Route } from "react-router-dom";

import "sass/main.scss"; // SASS
import "animate.css/animate.min.css";

// COMPONENTS
import Footer from "components/Footer";

// VIEWS
import Home from "views/Home";
import Protein from "views/Protein";
import Carbs from "views/Carbs";
import Fats from "views/Fats";
import Supps from "views/Supps";

const App = props => {
    return (
        <>
            <Switch>
                <Route path="/" exact component={Home} />
                <Route path="/protein" component={Protein} />
                <Route path="/carbs" component={Carbs} />
                <Route path="/fats" component={Fats} />
                <Route path="/supps" component={Supps} />
            </Switch>
            <Footer />
        </>
    );
};

export default App;
